<template>
  <div>
    <keep-alive>

      <dashboard-header
        class="white"
        :doctorName="doctorName"
      ></dashboard-header>
      
    </keep-alive>
    <div
      class="white"
    >
      <v-container
        class="white mb-3"
      >
        <v-layout wrap align-center>
          <v-flex
            class="display-1"
          >
            <strong>Your Dashboard</strong>
          </v-flex>
          <v-flex text-md-right>
            <v-layout align-center>
              <v-flex text-xs-right>
                <strong>CPD Points</strong>
                <div><em>as of {{ dateToday }}</em></div>
              </v-flex>
              <v-flex md2>
                <v-avatar color="primary">
                  <span class="white--text headline">{{ totalCpdPoints }}</span>
                </v-avatar>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

      </v-container>

      <v-tabs
        flat
        centered
        color="white"
        slot="extension"
        slider-color="primary"
        v-model="model"
      >
        <v-tab
          v-for="(tab, i) in tabs"
          :key="i"
          :href="`#tab-${tab.value}`"
        >
          {{ tab.text }}
        </v-tab>
      </v-tabs>
    </div>

    <v-tabs-items
      v-model="model"
    >
      <v-tab-item
        v-for="(tab, i) in tabs"
        :key="i"
        :id="`tab-${tab.value}`"
      >
        <component
          :is="tab.component"
          :modules="modules"
          :watchlist="watchlist"
          :addToWatchlist="addToWatchlist"
          :removeToWatchList="removeToWatchList"
          :user="user"
          :activities="activities"
          :certificates="certificates"
        ></component>
      </v-tab-item>
    </v-tabs-items>

    <v-footer 
      height="112"
    >
      <main-footer></main-footer>
    </v-footer>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import DashboardHeader from '@/components/dashboard/dashboardHeader'
import MainFooter from '@/components/mainFooter'
import LatestModules from '@/components/dashboard/latestModules'
import AllModules from '@/components/dashboard/allModules'
import Activities from '@/components/dashboard/activities'
import Authors from '@/components/dashboard/authors'
// import Watchlist from '@/components/dashboard/watchlist'
import AboutUs from '@/components/dashboard/aboutUs'
import Webinar from '@/components/dashboard/webinar'
import WebinarLinks from '@/components/dashboard/webinar_links'

import { getUser } from '@/utils/token'
import config from '../../../configApi'
const apiUrl = config.apiUrl

export default {
  components: {
    DashboardHeader,
    MainFooter,
    AllModules,
    LatestModules,
    Activities,
    Authors
  },
  // created () {
  //   this.token = JSON.parse(localStorage.getItem('token'))
  //   // if (!this.token) {
  //   //   this.$router.push('/')
  //   // } else {
  //   //   this.fetchData()
  //   // }
  // },
  computed: {
    totalCpdPoints () {
      return this.user.user_points ? this.user.user_points.points : 0
    },
    moduleData () {
      return this.modules
    },
    dateToday () {
      return moment().format('LL')
    }
  },
  data () {
    return {
      doctorName: 'Who',
      logo: require('@/assets/svg/ELITE Logo.svg'),
      model: 'tab-about_us',
      tabs: [
        {
          text: 'About ELITE',
          value: 'about_us',
          component: AboutUs
        },
        {
          text: 'About the Authors',
          value: 'authors',
          component: Authors
        },
        {
          text: 'All Modules',
          value: 'allModules',
          component: AllModules
        },
        {
          text: 'Latest Modules',
          value: 'latestModules',
          component: LatestModules
        },
        {
          text: 'Recorded Webinar',
          value: 'recorded_webinar',
          component: Webinar
        },
        {
          text: 'Thyroid Cheat Cards',
          value: 'webinar_links',
          component: WebinarLinks
        },
        {
          text: 'My Activities',
          value: 'activities',
          component: Activities
        }
      ],
      token: null,
      modules: this.serverData.modules,
      user: getUser(),
      activities: [],
      certificates: [],
      watchlist: [],
      userPoints: 0
    }
  },
  methods: {
    fetchData () {
      // this.getUserData()
      this.getActivities()
      this.getModules()
      this.getWatchlist()
      this.getPoints()
    },
    getPoints () {
      axios.get(`${apiUrl}/points/${this.user.id}`).then((res) => {
        if (res.data) {
          this.userPoints = res.data.points
        }
      })
    },
    getModules () {
      if (navigator.onLine) {
        console.log('User is online - Fetching info from server')
        axios.get(apiUrl + '/module').then((e) => {
          if (e.data.length > 0) {
            this.$set(this, 'modules', e.data)
          }
        }).catch((e) => {
          console.log('error', e)
        })
      } else {
        console.log('User is offline - Fetching info from localstorage')
      }
    },
    getActivities () {
      axios.get(apiUrl + '/user').then(r => {
        let prop = 'module_id'
        let userAssessment = r.data.user_assessment.sort((a, b) => a.created_at < b.created_at).filter((obj, pos, arr) => {
          return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos
        })
        // let watchList = r.data.watch_list.sort((a, b) => a.created_at < b.created_at).filter((obj, pos, arr) => {
        //   return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos
        // })
        this.activities = userAssessment
        this.certificates = r.data.certificate
      }).catch(e => {
      })
    },
    getWatchlist () {
      axios.get(`${apiUrl}/watchlist/${this.user.id}`).then((res) => {
        for (var watchmod of res.data) {
          this.watchlist.push(watchmod)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    addToWatchlist (module) {
      var data = {
        user_id: this.user.id,
        module_id: module.id
      }
      axios.post(`${apiUrl}/watchlist/${this.user.id}`, data).then((res) => {
        this.watchlist.push(res.data)
      }).catch((error) => {
        console.log(error)
      })
    },
    removeToWatchList (list) {
      var watchListIndex = this.watchlist.findIndex(i => i.id === list.id)
      axios.post(`${apiUrl}/watchlist/${list.id}/delete`, {}).then((res) => {
        this.watchlist.splice(watchListIndex, 1)
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  props: {
    apiUrl: String,
    serverData: {
      default () {
        return []
      }
    }
  },
  mounted () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/index.vue